@if(transmittal) {
    <div class="transmittal-details" style="width: 90%; margin: auto;">
        <div class="text-center" style="margin-top: 15px;">
            <button class="ace-btn btn-primary float-start" (click)="backClickedUI()">
                <i class="fa fa-arrow-left"></i>{{ shouldReturnToPaymentBatch ? 'Back to Payment Batch' : 'Back to Summary' }}
            </button>
            <h1 style="display: inline-block; margin: 0;">
                Package #: {{ selectedPackage.transmittalType }}
                @if (selectedPackage.completedDateTime) {
                    <span>-</span>
                }
                @if (!selectedPackage.completedDateTime) {
                    <span>Draft</span>
                }
                {{ selectedPackage.packageNumber }}
            </h1>
            <div class="float-end">
                <label>Transmittal:</label>
                <select 
                    class="form-select form-select-sm" 
                    style="width: auto; display: inline-block; margin-left: 10px;" 
                    [(ngModel)]="transmittal" 
                    (ngModelChange)="transmittalChanged($event)">
                        @for (transmittal of selectedPackage.paymentTransmittals; track transmittal) {
                            <option [ngValue]="transmittal">{{ transmittal.title }}</option>
                        }
                </select>
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="row" style="margin-top: 30px;">
            <div class="col-md-6 offset-md-1 offset-lg-2 col-lg-5 col-xl-4">
                <label>Collector</label>
                <div class="transmittal-address data-text-field" style="display: flex; justify-content: space-between; word-break: break-all;">
                    <address>
                        {{ transmittal.collectorName }}
                        <br> {{ transmittal.collectorAddress.address1 }}
                        <br> {{ transmittal.collectorAddress.address2 }}
                        @if (transmittal.collectorAddress.address2) {
                            <br>
                        } {{ transmittal.collectorAddress.city }}@if (transmittal.collectorAddress.city) {
                        <span>,</span>
                    } {{ transmittal.collectorAddress.abbr }} {{ transmittal.collectorAddress.zip }}
                    </address>
                    @if (collectorAddresses && collectorAddresses.length > 1) {
                        <button class="ace-btn btn-primary has-icon" (click)="editCollectorAddress()">
                            <i class="fa fa-pencil"></i>
                        </button>
                    }
                </div>
            </div>
            <div class="col-md-6 col-lg-5 col-xl-4">
                <label>Responsible Party</label>
                <div class="transmittal-address">
                    @if (recipients[RecipientType.ResponsibleParty] && recipients[RecipientType.ResponsibleParty][0]) {
                        <address>
                            {{ recipients[RecipientType.ResponsibleParty][0].companyName }}
                            <br> {{ recipients[RecipientType.ResponsibleParty][0].fullName }}
                            <br> {{ recipients[RecipientType.ResponsibleParty][0].title }}
                            @if (recipients[RecipientType.ResponsibleParty][0].address) {
                                <div>
                                    {{ recipients[RecipientType.ResponsibleParty][0].address.address1 }}
                                    <br> {{ recipients[RecipientType.ResponsibleParty][0].address.address2 }}
                                    @if (recipients[RecipientType.ResponsibleParty][0].address.address2) {
                                        <br>
                                    } {{ recipients[RecipientType.ResponsibleParty][0].address.city }}@if (recipients[RecipientType.ResponsibleParty][0].address.city) {
                                    <span>,</span>
                                } {{ recipients[RecipientType.ResponsibleParty][0].address.abbr }} {{ recipients[RecipientType.ResponsibleParty][0].address.zip }}
                                </div>
                            }
                        </address>
                    }
                </div>
                <div style="margin-top: 8px;">
                    @if (recipients[RecipientType.Cc]) {
                        <span>
                            <label>Cc:</label>
                            @for (cc of recipients[RecipientType.Cc]; track cc; let i = $index) {
                                <span>{{ cc.fullName }}@if (i !== (recipients[RecipientType.Cc].length - 1)) {
                                    <span>; </span>
                                }</span>
                            }
                            </span>
                    }
                    @if (recipients[RecipientType.Bcc]) {
                        <span>
                            <label>Bcc:</label>
                            @for (bcc of recipients[RecipientType.Bcc]; track bcc; let i = $index) {
                                <span>{{ bcc.fullName }}@if (i !== (recipients[RecipientType.Bcc].length - 1)) {
                                    <span>; </span>
                                }</span>
                            }
                            </span>
                    }
                </div>
            </div>
        </div>
        <div class="transmittal-details-items"
                [style.height]="isModal ? 'auto' : '400px'"
                [style.max-height]="isModal ? '400px;' : 'none'">
            <table class="table">
                <thead>
                <tr>
                    <th>Site Name</th>
                    <th>Parcel # / Collector #</th>
                    <th>Property Type</th>
                    <th class="text-end">Amount</th>
                    <th>Intake Item</th>
                    <th class="text-center">Bill Image</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                    @for (item of transmittal.paymentTransmittalItems; track item) {
                        <tr>
                            <td>{{ item.siteName }}</td>
                            <td>{{ item.acctNum }}@if (item.collectorAcctNum) {
                                <span> / {{ item.collectorAcctNum }}</span>
                            }</td>
                            <td>{{ constants.PropertyTypeNames[item.propertyType] }}</td>
                            <td class="text-end" style="width: 1px;">{{ item.amount | currency:'USD' }}</td>
                            <td>
                                {{ item.intakeBatchNumber }}@if (item.intakeItemNumber) {
                                <span>#{{ item.intakeItemNumber }}</span>
                            }
                            </td>
                            <td class="text-center">
                                @if (item.attachmentID) {
                                    <div class="btn-group" dropdown>
                                        <button type="button" class="ace-btn btn-sm btn-secondary" (click)="previewBill(item)" style="margin: 0">
                                            Pop-out
                                        </button><!--
                                -->
                                        <button type="button" dropdownToggle class="ace-btn btn-sm btn-secondary dropdown-toggle dropdown-toggle-split" style="margin: 0">
                                            <span class="caret"></span>
                                        </button>
                                        <ul *dropdownMenu class="dropdown-menu dropdown-menu-end" role="menu">
                                            <li role="menuitem">
                                                <a class="dropdown-item text-align-center" (click)="downloadBill(item)">
                                                    Download File
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                }
                            </td>
                            <td>
                                @if (transmittal.paymentTransmittalItems.length > 1 && !readOnly && !selectedPackage.completedDateTime && !selectedPackage.lockedForOverrideEmail) {
                                    <i class="fa fa-close" (click)="removeItem(transmittal, item)"></i>
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>

        <div class="row">
            <div class="col-md-4">
                <div class="mb-3">
                    <label>Note:</label>
                    <textarea
                        class="form-control"
                        rows="3"
                        maxlength="120"
                        [(ngModel)]="transmittal.note"
                        [disabled]="readOnly || !!selectedPackage.completedDateTime || !!selectedPackage.lockedForOverrideEmail"
                        (keydown)="preventCarouselFromInterceptingSpace($event)"></textarea>
                </div>
            </div>
            <div class="col-md-6">
                <table class="transmittal-data">
                    <tr>
                        <td>Total Amount:</td>
                        <td>{{ getTotalAmount(transmittal.paymentTransmittalItems) | currency:'USD' }}</td>
                    </tr>
                    <tr>
                        <td>Payment Due:</td>
                        <td>
                            <weissman-datetime [(inputDate)]="transmittal.dueDate" [readOnly]="true" [dateOnly]="true">
                            </weissman-datetime>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
}
